module.exports = __webpack_public_path__ + "img/portfolio-big-07.cf9db51f.png";